import { render, staticRenderFns } from "./my-account-modal.component.vue?vue&type=template&id=f4151426&scoped=true&"
import script from "./my-account-modal.component.vue?vue&type=script&lang=ts&"
export * from "./my-account-modal.component.vue?vue&type=script&lang=ts&"
import style0 from "./my-account-modal.component.vue?vue&type=style&index=0&id=f4151426&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4151426",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VChip,VCol,VRow,VSimpleTable})
